export const textareaLineHeight = 22;
export const textareaVerticalPaddings = 22;
export const borderWidth = 2;
